import api from '@pray/shared/utils/api';

export interface EmailCampaignStats {
  total: number;
  sent: number;
  scheduled: number;
  draft: number;
  sending: number;
  failed: number;
}

interface GetEmailCampaignStatsParams {
  artistId: string;
}

/**
 * Fetch email campaign statistics (aggregate counts)
 *
 * Returns accurate total, sent, scheduled, draft, sending, and failed counts
 * directly from the database without pagination.
 *
 * @param params.artistId - Artist ID (required)
 * @returns Promise with campaign stats
 */
interface EmailCampaignStatsApiResponse {
  data: Array<{ resource: EmailCampaignStats }>;
}

export async function getEmailCampaignStats({ artistId }: GetEmailCampaignStatsParams): Promise<EmailCampaignStats> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/emails/stats`;
  const response = await api.executeGetRequest<EmailCampaignStatsApiResponse>(url);

  // sendSuccessResponse wraps data as: { data: [{ resource: { ...stats } }] }
  const resource = response?.data?.data?.[0]?.resource;
  return resource || (response.data as unknown as EmailCampaignStats);
}
